import React from "react";
import { animated } from "react-spring/renderprops";
import "./app-semi-dark.css";
import "../../assets/scss/styles.scss";
import Header from "../commons/header";

function AppSemiDark(props) {
  return (
    <animated.div style={props.style}>
      <div className="fullwidth-semi-dark-bg">
        <Header className="sticky dark" />
        {props.children}
      </div>
    </animated.div>
  );
}

export default AppSemiDark;
